import { lazy } from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

export const UploadCreationTool = lazy(
    () => import("@mediaspace/features/bse/creation-tools/upload/UploadCreationTool")
);

export const UploadCreationToolButton = lazy(
    () => import("@mediaspace/features/bse/creation-tools/upload/UploadCreationToolButton")
);

export const RecorderCreationTool = lazy(
    () => import("@mediaspace/features/bse/creation-tools/recorder/RecorderCreationTool")
);

export const RecorderCreationToolButton = lazy(
    () => import("@mediaspace/features/bse/creation-tools/recorder/RecorderCreationToolButton")
);

export const YouTubeCreationTool = lazy(
    () => import("@mediaspace/features/bse/creation-tools/youtube/YoutubeCreationTool")
);

export const YouTubeCreationToolButton = lazy(
    () => import("@mediaspace/features/bse/creation-tools/youtube/YoutubeCreationToolButton")
);

const BrowseAndEmbed = lazy(() => import("@mediaspace/features/bse"));

export const render = getStandaloneComponentRenderer(BrowseAndEmbed);
